import script from "./DocPreviewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocPreviewPage.vue?vue&type=script&setup=true&lang=ts"

import "./DocPreviewPage.vue?vue&type=style&index=0&id=560657f7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560657f7"]])

export default __exports__